import axios from "axios";
import {BaseResponse} from "../../BaseResponse";
import {TankRelease} from "./getTankReleaseList";

export async function postTankRelease(tankRelease: TankRelease) {
    const response = await axios.post<BaseResponse<boolean>>('/tank/release', tankRelease)

    return response.data
}